export const GET_ALL_JOB_CARDS_TEMPLATE_FIELDS = 'GET_ALL_JOB_CARDS_TEMPLATE_FIELDS';
export const GET_ALL_JOB_CARDS_TEMPLATE_FIELDS_FAILED = 'GET_ALL_JOB_CARDS_TEMPLATE_FIELDS_FAILED';
export const UPDATE_JOB_CARDS_TEMPLATE_FIXED_FIELDS = 'UPDATE_JOB_CARDS_TEMPLATE_FIXED_FIELDS';
export const ADD_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS = 'ADD_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS';
export const UPDATE_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS = 'UPDATE_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS';

export function getJobCardsTemplate(data) {
  return {
    type: GET_ALL_JOB_CARDS_TEMPLATE_FIELDS,
    payload: data,
  }
}

export function getJobCardsTemplateFailed(data) {
  return {
    type: GET_ALL_JOB_CARDS_TEMPLATE_FIELDS_FAILED,
    payload: data,
  }
}

export function addCustomField(data) {
  return {
    type: ADD_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/jobCardsTemplate/index.js